import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Slide, toast, ToastContainer } from "react-toastify";
import FalconRoutes from "routes";
import { CloseButton } from "components/common/Toast";

import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.min.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./assets/CustomStyles/CustomCSS.css";

import { QAProvider } from "context/QAContext";
import { ZendeskProvider } from "context/ZendeskContext";
// import Chatbot from "components/Chatbot/Chatbot";
import { PaymentProvider } from "context/PaymentContext";
import { AuthProvider } from "context/AuthContext";

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <PaymentProvider>
          <ZendeskProvider>
            <QAProvider>
              <FalconRoutes />
              {/* <Chatbot /> */}
              <ToastContainer
                closeButton={CloseButton}
                icon={false}
                position={toast.POSITION.TOP_RIGHT}
                theme="light"
                transition={Slide}
              />
            </QAProvider>
          </ZendeskProvider>
        </PaymentProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
